import { render, staticRenderFns } from "./_base-NavBar.vue?vue&type=template&id=6b65c24c&scoped=true&"
import script from "./_base-NavBar.vue?vue&type=script&lang=js&"
export * from "./_base-NavBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b65c24c",
  null
  
)

export default component.exports